import type { ReactNode } from 'react'

import styles from './PartnerDetailsTitle.module.scss'

type PartnerDetailsTitleProps = {
  children: ReactNode
}

export const PartnerDetailsTitle = ({ children }: PartnerDetailsTitleProps) => (
  <h3 className={styles.root}>{children}</h3>
)

PartnerDetailsTitle.displayName = 'PartnerDetailsTitle'
